var map = {
	"./baac.png": "55b3",
	"./bay.png": "0a2b",
	"./bbl.png": "b92c",
	"./cimb.png": "964f",
	"./ghb.png": "6b4f",
	"./gsb.png": "c70b",
	"./ibank.png": "b077",
	"./icbc.png": "e207",
	"./kbank.png": "6b77",
	"./kk.png": "ae9b",
	"./ktb.png": "c650",
	"./lhb.png": "3f09",
	"./sc.png": "528b",
	"./scb.png": "2400",
	"./tbank.png": "9e12",
	"./tcd.png": "971e",
	"./tisco.png": "70bd",
	"./tmb.png": "4ab2",
	"./ttb.png": "f688",
	"./uob.png": "5daa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74b1";